import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FlameIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { RantInput } from '../components/RantInput';
import { getRandomIBDJoke } from '../utils/rantUtils';
import { APP_VERSION } from '../App';
const floatingEmojis = [{
  emoji: '💩🔥',
  y: -50,
  x: 20,
  duration: 8,
  delay: 0
}, {
  emoji: '💩🔥',
  y: -60,
  x: -15,
  duration: 10,
  delay: 1
}, {
  emoji: '💩🔥',
  y: -45,
  x: 25,
  duration: 9,
  delay: 2
}, {
  emoji: '💩🔥',
  y: -55,
  x: -20,
  duration: 11,
  delay: 3
}];
const joke = getRandomIBDJoke();
export const LandingPage: React.FC = () => {
  return <>
      <Helmet data-id="element-195">
        <title data-id="element-196">IBD Rant - A Safe Space to Vent About Life with IBD</title>
        <meta name="description" content="An anonymous community for people with Inflammatory Bowel Disease to share frustrations, vote on relatable rants, and know they're not alone in their IBD journey." data-id="element-197" />
        <meta name="version" content={APP_VERSION} data-id="element-198" />
        <meta property="og:title" content="IBD Rant - Vent About Life with IBD" data-id="element-199" />
        <meta property="og:description" content="An anonymous community for people with Inflammatory Bowel Disease to share frustrations, vote on relatable rants, and know they're not alone in their IBD journey." data-id="element-200" />
        <meta property="og:type" content="website" data-id="element-201" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-202" />
        <meta name="twitter:title" content="IBD Rant - Vent About Life with IBD" data-id="element-203" />
        <meta name="twitter:description" content="An anonymous community for people with Inflammatory Bowel Disease to share frustrations, vote on relatable rants, and know they're not alone in their IBD journey." data-id="element-204" />
      </Helmet>
      <Header data-id="element-205" />
      <main className="flex-grow py-12 px-4 relative overflow-hidden" data-id="element-206">
        {/* Floating Flaming Poop Emojis */}
        {floatingEmojis.map((item, index) => <motion.div key={index} className="absolute text-4xl pointer-events-none" style={{
        left: `${20 + index * 20}%`,
        top: `${30 + index % 2 * 20}%`
      }} initial={{
        opacity: 0,
        y: 0
      }} animate={{
        opacity: [0, 1, 1, 0],
        y: [0, item.y, item.y * 2, item.y * 3],
        x: [0, item.x, -item.x, item.x],
        rotate: [0, 10, -10, 0]
      }} transition={{
        duration: item.duration,
        delay: item.delay,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-207">
            {item.emoji}
          </motion.div>)}
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-208">
          <motion.div className="text-center mb-12" initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-209">
            <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} data-id="element-210">
              What Pisses You Off About IBD?
            </motion.h1>
            <motion.p className="text-xl text-text-secondary mb-8" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.4,
            duration: 0.5
          }} data-id="element-211">
              Let it out your mouth, it's already coming out your butt.
            </motion.p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.6,
          duration: 0.5
        }} data-id="element-212">
            <RantInput data-id="element-213" />
          </motion.div>
          <motion.div className="text-center mt-8 mb-12" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.9,
          duration: 0.5
        }} data-id="element-214">
            <div className="bg-background-light border-2 border-gray-800 rounded-lg p-6 max-w-2xl mx-auto" data-id="element-215">
              <p className="text-text-primary text-lg italic" data-id="element-216">"{joke}"</p>
            </div>
          </motion.div>
          <motion.div className="text-center" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.0,
          duration: 0.5
        }} data-id="element-217">
            <Link to="/hall-of-rage" className="text-primary hover:text-primary-hover flex items-center justify-center gap-2 font-semibold" data-id="element-218">
              <FlameIcon className="h-5 w-5" data-id="element-219" />
              See what others are ranting about
            </Link>
          </motion.div>
        </div>
      </main>
      <Footer data-id="element-220" />
    </>;
};